module.exports = __webpack_public_path__ + "static/media/time.5d878227.svg";